import { render, staticRenderFns } from "./config-documentos.vue?vue&type=template&id=ffcda87e&scoped=true&"
import script from "./config-documentos.component.ts?vue&type=script&lang=ts&"
export * from "./config-documentos.component.ts?vue&type=script&lang=ts&"
import style0 from "./config-documentos.vue?vue&type=style&index=0&id=ffcda87e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcda87e",
  null
  
)

export default component.exports